/* 孫吳傳・第 13 章：落水呼韓當（建安十三年，208）
 * 史實：《吳書》（裴注，《黃蓋傳》）「赤壁之役，蓋爲流矢所中，時寒墮水，爲吳軍人所得，不知其蓋也，置廁牀中。
 *       蓋自彊以一聲呼當，當聞之，曰：『此公覆聲也。』向之垂涕，解易其衣，遂以得生。」
 * 流程：（第 12 章「火船・落水」的第二幕）操作韓當，在南岸的吳營裡找黃蓋。從江裡撈起來的傷兵躺了一地，看起來都一樣；
 *       黃蓋每隔幾秒「一聲呼」，畫面上只閃一下方向，聲音越來越弱。站在傷兵旁邊察看，認出黃蓋就替他換衣。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, PEOPLE } from '../kit.ts';

const CAMP = [4600, 4550], LV = 11, LIFE = 90, N = 22;
const CALLS = ['「義公！」', '「義公……」', '「……義公……」', '「……」'];
const WRONG = ['……水……給我水……', '不是……我是丹陽的兵……', '冷……好冷……', '我叫什麼……想不起來了……', '將軍……我的腿……'];

export default {
  id: 'sunwu-13', of: 'sunwu-12', map: 'chibi', hero: 'handang', heroSpec: PEOPLE.handang,
  title: '第 11 章　火船・落水（下）', year: '建安十三年（208）',
  brief: {
    quote: [{ text: '蓋爲流矢所中，時寒墮水，爲吳軍人所得，不知其蓋也，置廁牀中。', src: '《吳書》（裴注）' }],
    text: '火攻得手，黃蓋卻在撤退時中箭落水。吳軍從江裡撈起一大批傷兵，沒人認得出他，把他和其他人放在一起。',
    goals: ['在傷兵裡找到黃蓋', '替他換下濕衣'],
  },
  stars: [ // 兩幕合算：火船兩顆、落水一顆
    { text: '火船：疑心一直沒超過一半', ok: (m) => !m.prev || m.prev.vars.susMax < 50 },
    { text: '火船：火燒到岸上的營落', ok: (m) => !m.prev || !!m.prev.vars.shore },
    { text: '落水：45 秒內找到黃蓋', ok: (m) => m.vars.foundT != null && m.vars.foundT <= 45 },
  ],
  steps: [
    { // 1. 找人
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = CAMP[0] - 900; me.y = CAMP[1] - 300;
        V.wrong = 0; V.t0 = w.t; V.callT = 3;
        const R = SG.rand;
        const spots = [];
        for (let tries = 0; spots.length < N && tries < 800; tries++) {
          const a = R() * Math.PI * 2, d = 200 + R() * 900, x = CAMP[0] + Math.cos(a) * d, y = CAMP[1] - 200 + Math.sin(a) * d * 0.55;
          if (SG.MAP.walkable(x, y, SG.MAP.BODY) && !SG.MAP.waterAt(x, y) && spots.every((p) => SG.gd(p[0], p[1], x, y) > 150)) spots.push([x, y]);
        }
        const gi = 4 + Math.floor(R() * (spots.length - 4));
        V.men = spots.map(([x, y], i) => m.folk(x, y, { name: i === gi ? '黃蓋' : '傷兵', still: true, near: 1, lying: true, cloth: ['#7f2a24', '#6e2a22', '#8a3a2a'][i % 3], gai: i === gi }));
        V.gai = V.men[gi];
        m.card('爲吳軍人所得，不知其蓋也，置廁牀中。', '《吳書》');
        m.line('韓當', '公覆呢？有人看到黃公覆嗎？');
        m.after(4, () => m.line('提示', '黃蓋會隔一陣子喊一聲，畫面上只閃一下方向。走到傷兵身邊停一下就能察看。'));
        m.obj('find', '在傷兵裡找到黃蓋');
        m.obj('life', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, left = LIFE - (w.t - V.t0);
        m.get('life').text = `黃蓋的力氣：${Math.max(0, Math.round((100 * left) / LIFE))}%`;
        if (left <= 0) { m.lose('黃蓋沒撐住'); return false; }
        // 一聲呼：越來越弱、間隔越來越長
        V.callT -= dt;
        if (V.callT <= 0) {
          const k = Math.min(CALLS.length - 1, Math.floor((w.t - V.t0) / (LIFE / CALLS.length)));
          V.callT = 6 + k * 1.5;
          m.line('？', CALLS[k]);
          m.mark('call', V.gai.x + (SG.rand() - 0.5) * 160 * k, V.gai.y + (SG.rand() - 0.5) * 100 * k, '呼聲');
          m.after(1.4, () => m.unmark('call'));
        }
        // 察看：站在傷兵身邊 1 秒
        for (const f of V.men) {
          if (f.checked && !f.gai) continue;
          m.chanAt(me, 'chk' + V.men.indexOf(f), f.x, f.y, 90, 1, '察看', () => {
            if (f.gai) { V.found = true; return; }
            f.checked = true; V.wrong++;
            m.line('傷兵', WRONG[V.wrong % WRONG.length]);
          });
        }
        return !!V.found;
      },
    },
    { // 2. 此公覆聲也：解易其衣
      enter(m, w) {
        const V = m.vars;
        V.foundT = w.t - V.t0;
        m.done('find'); m.unmark('call');
        m.line('韓當', '此公覆聲也！');
        m.after(1.5, () => m.line('黃蓋', '……義公……'));
        m.obj('cloth', '替黃蓋換下濕衣');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        m.chanAt(me, 'cloth', V.gai.x, V.gai.y, 110, 3, '解易其衣', () => { V.done = true; });
        return !!V.done;
      },
    },
    { // 3. 遂以得生
      enter(m) {
        m.done('cloth'); m.drop('life');
        m.card('當聞之，曰：「此公覆聲也。」向之垂涕，解易其衣，遂以得生。', '《吳書》');
        m.after(6, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) { if (!w.player.alive) m.lose('韓當倒下了'); },
};
